import React, { useEffect, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import App from '../app';
import { fetchTrackingAction } from '../actions/tracking';

export function TrackingPageApp(props) {
  const { trackingPageId, orderId, zipCode, initialized, status, fetchData } = props;

  useEffect(() => {
    fetchTrackingData();
  }, []);

  const fetchTrackingData = useCallback(
    (language) => {
      fetchData && fetchData(trackingPageId, orderId, zipCode, language);
    },
    [orderId, trackingPageId, zipCode, fetchData]
  );

  const isDummy = isDummyOrderId(orderId);

  if (!isDummy && initialized && status !== 'published') {
    return null;
  }

  return <App isDummy={isDummy} onChangeLanguage={fetchTrackingData} />;
}

TrackingPageApp.propTypes = {
  trackingPageId: PropTypes.string,
  orderId: PropTypes.string,
  fetchData: PropTypes.func,
  initialized: PropTypes.bool,
  status: PropTypes.string,
};

function isDummyOrderId(orderId) {
  return orderId === '<orderId>';
}

function mapStateToProps(state) {
  const {
    settings: {
      initialized,
      settings: { status, localization },
      loaded: isSettingsLoaded,
    },
  } = state;

  return {
    initialized,
    status,
    shopId: localization && localization.shopId,
    isSettingsLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchData: (...args) => dispatch(fetchTrackingAction(...args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(TrackingPageApp));
